// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2PcG5","savePackageButton":"ClientWallet_savePackageButton__2xbE8"};